import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg width="60" height="54" viewBox="0 0 60 54" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinejoin="round">
        <path d="M11 29.82V42.5L30 53l19-10.5V29.82M11 17.5L30 7l19 10.5" />
        <path d="M11 17.5L0 11.42 18.76.78 30 7m19 10.5l11-6.08L41.26.78 30 7m19 10.5l11 6.08-18.74 10.64L30 28zM30 53V28l-11.24 6.22L0 23.58l11-6.08L30 28" />
      </g>
    </svg>
  </span>
);

export default icon;
